import styled from "styled-components";

export const CustomerStatisticsPageContainer = styled.div`
    background-color: #fff;
    border-radius: 8px;
    padding: 24px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    width: 100%;

    .customer-statistics-tabs {
        .ant-tabs-tab {
            padding: 12px 16px;
            font-weight: 500;

            &.ant-tabs-tab-active {
                .ant-tabs-tab-btn {
                    color: #000000;
                    font-weight: 600;
                }
            }
        }

        .ant-tabs-ink-bar {
            background: #000000;
        }

        .ant-tabs-content-holder {
            padding-top: 24px;
        }

        @media screen and (max-width: 768px) {
            .ant-tabs-tab {
                padding: 10px 12px;
                font-size: 14px;
            }

            .ant-tabs-content-holder {
                padding-top: 16px;
            }
        }

        @media screen and (max-width: 480px) {
            .ant-tabs-tab {
                padding: 8px 10px;
                font-size: 13px;
            }

            .ant-tabs-content-holder {
                padding-top: 12px;
            }
        }
    }

    @media screen and (max-width: 768px) {
        padding: 16px;
        border-radius: 6px;
    }

    @media screen and (max-width: 480px) {
        padding: 12px;
        border-radius: 4px;
    }
`;
